export const EMPTY = '';
export const TAB_GROUP = 'tabGroup';
export const PRODUCER_ID = 'producer.$id';

export function normalizeUpperCase(value?: string | null): string {
    return value?.trim().toUpperCase() ?? EMPTY;
}
